import './index.css'
import React from 'react'
// import { useNavigate } from 'react-router-dom'
// import { useDispatch } from 'react-redux'
import { Box, Typography } from '@mui/material'
// import { ExitIcon } from 'assets/vault icons/exit'

const sx={
  header: {
    color:'#25245F',
    marginLeft: '15px'
  }
}

const Header = props => {

  return (
<Box>
  <Typography variant='h4' sx={sx.header}>
  {props.title}
  </Typography>
</Box>
  )
}

export default Header
